// @ts-nocheck

import React, { useEffect, useState } from "react";
import SoftBox from "../../../components/common/softBox";
import SoftTypography from "../../../components/common/softTypography";
import SoftInput from "../../../components/common/softInput";
import SoftButton from "../../../components/common/softButton";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { FaCircleMinus, FaCirclePlus } from "react-icons/fa6";
import { editAmenity, getAmenityById } from "../../../features/amenity";

const EditAmenity = () => {
  const { id } = useParams<{ id: string }>();
  const { amenity, status } = useSelector((state: any) => state.amenity); // Adjust state as necessary
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    description: "",
    popular: false,
    is_more: true,
    photo: null,
  });

  useEffect(() => {
    // Fetch amenity data by ID
    dispatch(getAmenityById(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (status && amenity) {
      const data = amenity.data;
      setFormData({
        name: data.name,
        description: data.description,
        popular: data.popular,
        is_more: data.is_more,
        photo: data.photo,
      });
    }
  }, [status, amenity]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>, field: string) => {
    setFormData((prev) => ({
      ...prev,
      [field]: e.target.checked,
    }));
  };

  const handleThumbnailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFormData((prev) => ({
        ...prev,
        photo: e.target.files[0], // Handle thumbnail image change
      }));
    }
  };

  const handleSubmit = () => {
    const formDataFinal = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formDataFinal.append(key, value);
      }
    });

    dispatch(editAmenity({ id, updatedAmenity: formDataFinal }))
      .then((res: any) => {
        toast.success(res.payload.message); // Assuming you have a toast function
        navigate("/amenity"); // Redirect to amenities list or another page
      })
      .catch((err: any) => {
        console.error(err, "error");
        toast.error("An error occurred while updating the amenity.");
      });
  };

  return (
    <SoftBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      bgColor="white"
      shadow="lg"
      borderRadius="lg"
      p={4}
    >
      {/* Form Container */}
      <SoftBox width="100%" maxWidth="400px">
        <SoftBox mb={2}>
          <SoftTypography variant="h4" fontWeight="bold" textAlign="center">
            Edit Amenity
          </SoftTypography>
        </SoftBox>

        <SoftBox component="form" role="form">
          {/* Name Input */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Name
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="name"
              placeholder="Enter the amenity name"
              value={formData.name}
              onChange={handleChange}
            />
          </SoftBox>

          {/* Description Input */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Description
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="description"
              placeholder="Enter the amenity description"
              value={formData.description}
              onChange={handleChange}
            />
          </SoftBox>

          {/* Popular Checkbox */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Popular
              </SoftTypography>
            </SoftBox>
            <input
              type="checkbox"
              name="popular"
              checked={formData.popular}
              onChange={(e) => handleCheckboxChange(e, "popular")}
            />
          </SoftBox>

          {/* Is More Checkbox */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Is More
              </SoftTypography>
            </SoftBox>
            <input
              type="checkbox"
              name="is_more"
              checked={formData.is_more}
              onChange={(e) => handleCheckboxChange(e, "is_more")}
            />
          </SoftBox>

          {/* Photo Input */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Photo
              </SoftTypography>
            </SoftBox>
            {formData.photo && (
              <img
                src={formData.photo.name ? URL.createObjectURL(formData.photo) : formData.photo}
                alt="photo"
                style={{ width: "150px", height: "150px", borderRadius: "5px" }}
              />
            )}
            <input
              type="file"
              name="photo"
              onChange={handleThumbnailChange}
              style={{ width: "100%" }}
            />
          </SoftBox>

          {/* Submit Button */}
          <SoftBox mt={4} mb={1}>
            <SoftButton variant="gradient" color="info" fullWidth onClick={handleSubmit}>
              Submit
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default EditAmenity;
